import * as React from "react";
import TicketEventsTableContainer from "../../TicketEvents/TicketEventsTableContainer";

export default class TicketEventsAll extends React.Component<any> {
  componentDidMount() {
    this.props.setHeader({
      title: "Events > All Events",
      description: "View all events",
    });
  }

  render() {
    return (
      <TicketEventsTableContainer
        name="events.all"
        mode="all"
        emptyStateMessage="No events found"
      />
    );
  }
}
